<app-uig-navigation-ui [node]="node$ | async" [ngClass]="styleClass$ | async">
</app-uig-navigation-ui>
